module.exports = __webpack_public_path__ + "img/icon_map_62_on_001.469eb8e8.png";